import { useWindowDimensions } from '@/modules/common/hooks/use-window-dimensions.hook';
import styles from './index.module.sass';
import verticalIcon from '@@/mixing/components/recipes-detail/icons/arrow-vertical.svg';
import iconInfo from '@@/mixing/images/info-icon.svg';
import {
  BestPriceBuyerItem,
  IBestPriceBagItem,
} from '@/modules/mixing/store/analytical-mixing.store';
import classNames from 'classnames';
import { RecipesService } from '@/modules/common/services/recipes.service';
import { RubleRegular } from '@/modules/common/components/ruble-regular';

export const BusinessInfo = ({
  className,
  isStationary,
  offer,
  TARGET_MOISTURE,
  data,
  price_before_moisture_mod,
  price_after_moisture_mod,
  setActionState,
  setModalViewOnly,
  setModalOpen,
  actionState,
}: {
  actionState: 'drain' | 'hydrate' | null;
  className?: string;
  isStationary: boolean;
  offer?: BestPriceBuyerItem;
  TARGET_MOISTURE: number;
  data: IBestPriceBagItem;
  price_before_moisture_mod: number;
  price_after_moisture_mod: number;
  setActionState: (val: 'drain' | 'hydrate' | null) => void;
  setModalViewOnly: (val: boolean) => void;
  setModalOpen: (val: boolean) => void;
}) => {
  const { width } = useWindowDimensions();
  const recipesService = offer && new RecipesService(offer, data);
  const hydartedCasePrices = recipesService?.calculateHydrateParams();
  const drainCasePrices = recipesService?.calculateDrainParams();
  const bagHumidity = +data.values.humidity;
  const offerHumidity = data.offer_humidity;

  return (
    <div className={classNames(styles.businessInfo, className)}>
      <div className={styles.row}>
        <span className={styles.label}>
          {isStationary ? 'стоимость объема' : 'стоимость рукава'}{' '}
          {offer?.freight_price && offer.distance ? 'без учета логистики' : ''}
        </span>
        {TARGET_MOISTURE > +data.values.humidity &&
        data.weight !== data.weight + data.weight_gain_tons ? (
          <span className={classNames(styles.value, width <= 1920 && styles.minified)}>
            {(data.weight * Number(offer?.price_per_ton)).toLocaleString('ru', {
              maximumFractionDigits: 0,
            })}{' '}
            <RubleRegular/>{' '}
            <span className={styles.innerRegular}>
              (
              {data.weight.toLocaleString('ru', {
                maximumFractionDigits: 1,
              })}
              т)
            </span>{' '}
            {width > 1920 ? (
              '-'
            ) : (
              <div className={styles.actionType}>
                <img src={verticalIcon} /> 
                {TARGET_MOISTURE > +data.values.humidity
                  ? ' после увлажнения'
                  : 'после осушения'}
              </div>
            )}{' '}
            {(
              (data.weight + data.weight_gain_tons) *
              Number(offer?.price_per_ton)
            ).toLocaleString('ru', { maximumFractionDigits: 0 })}{' '}
            <RubleRegular/>{' '}
            <span className={styles.innerRegular}>
              (
              {(data.weight + data.weight_gain_tons).toLocaleString('ru', {
                maximumFractionDigits: 1,
              })}
              т)
            </span>
          </span>
        ) : (
          <span className={styles.value}>
            {(
              (data.weight + data.weight_gain_tons) *
              Number(offer?.price_per_ton)
            ).toLocaleString('ru', { maximumFractionDigits: 0 })}{' '}
            <span className={styles.innerRegular}>
            <RubleRegular/> (
              {(data.weight + data.weight_gain_tons).toLocaleString('ru', {
                maximumFractionDigits: 1,
              })}{' '}
              т)
            </span>
          </span>
        )}
      </div>
      <div className={styles.row}>
        <span className={styles.label}>
          {offer?.freight_price && offer.distance
            ? isStationary
              ? 'стоимость объема с уч. логистики'
              : 'стоимость рукава с уч. логистики'
            : isStationary
            ? 'конечная стоимость объема'
            : 'конечная стоимость рукава'}{' '}
          <span className={styles.innerRegular}></span>
        </span>
        <span
          className={styles.value}
          style={{ cursor: 'pointer' }}
          onClick={
            price_before_moisture_mod === price_after_moisture_mod
              ? offerHumidity > bagHumidity ? () => {
                setActionState(
                  TARGET_MOISTURE < +data.values.humidity ? 'drain' : 'hydrate',
                );
                setModalViewOnly(true);
                setModalOpen(true);
              } : undefined
              : () => {
                  setActionState(
                    TARGET_MOISTURE < +data.values.humidity ? 'drain' : 'hydrate',
                  );
                  setModalViewOnly(true);
                  setModalOpen(true);
                }
          }
        >
          {price_before_moisture_mod !== price_after_moisture_mod ? (
            <>
              {actionState === 'drain'
                ? <>{drainCasePrices?.drainAfter.netto.toLocaleString('ru', {
                    maximumFractionDigits: 0,
                  })} <RubleRegular/> - {drainCasePrices?.drainBefore.netto.toLocaleString('ru', {
                    maximumFractionDigits: 0,
                  })} <RubleRegular/></>
                : actionState === 'hydrate'
                ? <>{(
                    data.weight * (offer?.price_per_ton || 0) -
                    data.freight_cost_before_moisture_mod
                  ).toLocaleString('ru', {
                    maximumFractionDigits: 0,
                  })} <RubleRegular/> - {hydartedCasePrices?.hydrateAfter.netto.toLocaleString('ru', {
                    maximumFractionDigits: 0,
                  })} <RubleRegular/></>
                : <>{(
                    (data.weight + data.weight_gain_tons) *
                      (offer?.price_per_ton || 0) -
                    (offer?.freight_price || 0)
                  ).toLocaleString('ru', {
                    maximumFractionDigits: 0,
                  })} <RubleRegular/></>}
            </>
          ) : actionState === 'hydrate' ? (
            <>{(data.weight * (offer?.price_per_ton || 0)).toLocaleString('ru', {
              maximumFractionDigits: 0,
            })} <RubleRegular/> - {(
              (data.weight + data.weight_gain_tons) *
              (offer?.price_per_ton || 0)
            ).toLocaleString('ru', { maximumFractionDigits: 0 })} <RubleRegular/></>
          ) : <>{(
            price_before_moisture_mod.toLocaleString('ru', {
              maximumFractionDigits: 0,
            })
          )} <RubleRegular/></>}
          {price_before_moisture_mod === price_after_moisture_mod ? (
            offerHumidity > bagHumidity ? (
              <img alt="info" src={iconInfo} />
            ) : (
              ''
            )
          ) : (
            <img alt="info" src={iconInfo} />
          )}
        </span>
      </div>
    </div>
  );
};
